import { Duration } from "@js-joda/core";
import React from "react";
import { VisitInstanceDetails } from "../../../messages";
import { STRINGS } from "../../../strings";
import { globalize, translate } from "../../../translate";
import { VisitExtraHeader } from "./VisitExtraHeader";

export default function VisitInstanceExtraHeader(props: {
  visit: VisitInstanceDetails;
  onGoToVisit: () => void;
}) {
  const { visit } = props;

  return (
    <VisitExtraHeader
      patientInitials={visit.publicVisitDetails.patientInitials}
      startTimeLocal={visit.publicVisitDetails.startTimeLocal}
      endTimeLocal={
        visit.publicVisitDetails.endTimeLocal ?? visit.publicVisitDetails.startTimeLocal
      }
      location={visit.publicVisitDetails.location}
      price={visit.publicVisitDetails.price}
      visitType={translate(STRINGS.SINGLE_VISIT_TYPE)}
      visitDuration={getVisitDuration(visit)}
      onGoToVisit={props.onGoToVisit}
    />
  );
}

function getVisitDuration(visit: VisitInstanceDetails) {
  const { startTimeLocal, endTimeLocal } = visit.publicVisitDetails;

  if (endTimeLocal === undefined) {
    return null;
  }

  const hours = Duration.between(startTimeLocal, endTimeLocal).toHours();

  return globalize().formatUnit(hours, "hour");
}
